import { createApp } from 'vue'
import App from './App.vue'
/* eslint-disable */
import ZenDataComponent from './components/ZenData.vue'
import ZenFileComponent from './components/ZenFile.vue'
import ZenChunkComponent from './components/ZenChunk.vue'
import ZenPATaZCORComponent from './components/ZenPATaZCOR.vue'
import ZenArrayComponent from './components/ZenArray.vue'

const app = createApp(App);

app.component('ZenDataComponent', ZenDataComponent);
app.component('ZenFileComponent', ZenFileComponent );
app.component('ZenPATaZCORComponent',ZenPATaZCORComponent );
app.component('ZenArrayComponent', ZenArrayComponent);
app.component('ZenChunkComponent', ZenChunkComponent);
//    .component('', )

app.config.globalProperties.$filters = {
    hex8(val) {
        return "0x"+("00" + (val).toString(16)).substr(-2)+" ("+val+")";
    },
    hex16(val) {
        return "0x"+("0000" + (val).toString(16)).substr(-4)+" ("+val+")";
    },
    hex24(val) {
        return "0x"+("000000" + (val).toString(16)).substr(-6)+" ("+val+")";
    },
    hex32(val) {
        return "0x"+("000000" + (val).toString(16)).substr(-8)+" ("+val+")";
    },
}


app.mount('#app')
